import React from 'react'

const EtDeleteUserImprintEt = () => {
  return (
    <div>EtDeleteUserImprintEt</div>
  )
}

export default EtDeleteUserImprintEt